import { Draggable } from 'react-beautiful-dnd';
import { useCallback } from 'react';
import { TabComponent } from './TabComponent';
import { TabContents } from './TabContents';
import styled, { css } from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const ENTER_KEY_KEYCODE = 13;
const StyledTabComponent = styled(TabComponent).withConfig({
  displayName: "ViewTab__StyledTabComponent"
})(["", ""], ({
  tabStyle
}) => tabStyle === 'modern' && css(["&:first-of-type{border-top-left-radius:", ";}&:last-of-type{border-top-right-radius:", ";}"], ({
  theme
}) => theme.borderRadius['100'], ({
  theme
}) => theme.borderRadius['100']));
export const ViewTab = ({
  icon,
  scrollToRef,
  isDragDisabled,
  tabId,
  index,
  children,
  active,
  onCloseClick,
  onTabClick,
  closeDisabled,
  closeTooltip,
  tabStyle = 'legacy'
}) => {
  const onTabClickFunction = useCallback(() => {
    onTabClick(tabId);
  }, [onTabClick, tabId]);
  const onCloseClickFunction = useCallback(() => onCloseClick(tabId), [onCloseClick, tabId]);
  const onKeyDownFunction = useCallback(e => {
    if (e.which === ENTER_KEY_KEYCODE) {
      onTabClickFunction();
    }
  }, [onTabClickFunction]);
  return /*#__PURE__*/_jsx(Draggable, {
    //this and draggableId are very important for react-beautiful-dnd - they must be unique
    draggableId: tabId,
    index: index //index must be the index of this tab within the array, (it cannot be something arbitrary like key)
    ,
    isDragDisabled: isDragDisabled,
    children: (provided, snapshot) =>
    /*#__PURE__*/
    /* @bend-expect trellis-tokenized */
    _jsx(StyledTabComponent, Object.assign({
      role: "tab",
      "aria-selected": active,
      active: active,
      onClick: onTabClickFunction,
      onKeyDown: onKeyDownFunction,
      ref: provided.innerRef,
      "data-tab-id": tabId,
      "data-test-id": `view-tab-${tabId}`,
      "data-onboarding": 'view-tab',
      canDropInCurrentLocation: Boolean(snapshot.draggingOver),
      tabStyle: tabStyle
    }, provided.draggableProps, provided.dragHandleProps, {
      children: /*#__PURE__*/_jsx(TabContents, {
        active: active,
        scrollToRef: scrollToRef,
        closeDisabled: closeDisabled,
        closeTooltip: closeTooltip,
        onCloseClickFunction: onCloseClickFunction,
        isDragDisabled: isDragDisabled,
        tabId: tabId,
        icon: icon,
        children: children
      })
    }))
  }, tabId);
};